import React from "react";
import Navbar1 from "./Navbar";
import facebookIcon from "../assets/navbar/facebook.png";
import { Container } from "react-bootstrap";
import ImmagineCopertina from "../assets/about-us/10 - Copia.png";

const AboutUs = () => {
  return (
    <>
      <Navbar1 />
      <Container fluid style={{ padding: "0px", position: "relative", textAlign: "center" }}>
        <img
          src={ImmagineCopertina}
          alt="Copertina"
          className="img-fluid"
          id="responsive"
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </Container>

      {/* Sezione Su di noi */}
      <div
        className="extra-section"
        style={{ marginTop: "50px", padding: "40px 20px", backgroundColor: "#f8f1e7", marginBottom: "40px" }}
      >
        <div className="extra-section-content" style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <div className="extra-section-text" style={{ flex: 1, padding: "20px", textAlign: "left" }}>
            <h2 style={{ fontFamily: "Playfair Display, serif", color: "black", marginBottom: "20px" }}>Su di noi</h2>
            <p style={{ fontFamily: "Montserrat, sans-serif", color: "#555" }}>
              <strong>Starblack</strong> nasce con l'obiettivo di rappresentare l'uomo e la donna contemporanei
              attraverso esclusività e <strong>Made in Italy</strong>. Desideriamo permettere ai nostri clienti di
              brillare come stelle, esprimendo la loro unicità senza mai sacrificare eleganza, praticità e comfort.
            </p>
            <p
              style={{ fontFamily: "Montserrat, sans-serif", color: "#333", maxWidth: "800px", margin: "20px auto 0" }}
            >
              Designer e artigiani qualificati lavorano con passione per creare prodotti di altissima qualità, offrendo
              anche la possibilità di realizzare gioielli su misura e <strong>personalizzabili</strong>.
            </p>
          </div>
          <div className="extra-section-image" style={{ flex: 1, textAlign: "center", padding: "20px" }}>
            <img src="/assets/3.jpg" alt="Our Mission" style={{ maxWidth: "70%", borderRadius: "10px" }} />
          </div>
        </div>
      </div>

      {/* Sezione Mission */}
      <div
        className="noi-section"
        style={{ marginTop: "50px", padding: "40px 20px", backgroundColor: "#f9f9f9", textAlign: "center" }}
      >
        <h2 style={{ fontFamily: "Playfair Display, serif", color: "#b3870b", marginBottom: "20px" }}>Mission</h2>
        <p style={{ fontFamily: "Montserrat, sans-serif", color: "#555", maxWidth: "800px", margin: "0 auto" }}>
          La nostra missione è creare gioielli esclusivi e di alta qualità, rappresentando l'eccellenza del Made in
          Italy. Vogliamo offrire ai nostri clienti la possibilità di esprimere la propria unicità e personalità
          attraverso gioielli eleganti, pratici e confortevoli, realizzati con cura e passione dai nostri designer e
          artigiani.
        </p>
      </div>

      {/* Sezione Vision */}
      <div
        className="extra-section"
        style={{ marginTop: "50px", padding: "40px 20px", backgroundColor: "#f8f1e7", marginBottom: "40px" }}
      >
        <div className="extra-section-content" style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <div className="extra-section-text" style={{ flex: 1, padding: "20px", textAlign: "left" }}>
            <h2 style={{ fontFamily: "Playfair Display, serif", color: "black", marginBottom: "20px" }}>Vision</h2>
            <p style={{ fontFamily: "Montserrat, sans-serif", color: "#555" }}>
              Aspiriamo a diventare un punto di riferimento nel mondo della gioielleria di lusso, combinando tradizione
              e innovazione per creare pezzi unici che rispecchino l'anima e il carattere di chi li indossa. Vogliamo
              essere riconosciuti per la nostra attenzione ai dettagli, la qualità dei nostri materiali e la capacità di
              personalizzare ogni gioiello per soddisfare i desideri e le aspettative dei nostri clienti.
            </p>
          </div>
          <div className="extra-section-image" style={{ flex: 1, textAlign: "center", padding: "20px" }}>
            <img src="/assets/vision.png" alt="Our Vision" style={{ maxWidth: "80%", borderRadius: "10px" }} />
          </div>
        </div>
      </div>

      {/* Sezione Storie e Testimonianze */}
      <div
        className="stories-testimonials-section"
        style={{ padding: "40px 20px", backgroundColor: "#f9f9f9", textAlign: "center" }}
      >
        <h2 style={{ fontFamily: "Playfair Display, serif", color: "#d4a373", marginBottom: "40px" }}>
          Storie e Testimonianze
        </h2>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div
            className="testimonial"
            style={{
              maxWidth: "600px",
              textAlign: "center",
              marginBottom: "20px",
              fontFamily: "Montserrat, sans-serif",
              color: "#555",
            }}
          >
            <p>
              "Persone cordiali, grande serietà e professionalità!!! Consigliatissimo per chi è alla ricerca di un
              gioiello unico e che sappia veramente stupire!!"
            </p>
            <p style={{ fontStyle: "italic" }}>- Annalisa - </p>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <a href="https://www.facebook.com/starblackgioielli" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" style={{ width: "24px", height: "24px" }} />
          </a>
          <p style={{ fontFamily: "Montserrat, sans-serif", color: "#555", marginTop: "10px" }}>
            Seguiteci su Facebook per più testimonianze e aggiornamenti!
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
